import React, {memo} from 'react';
import YtPlayer from 'react-player/youtube';
import Block from '../block';
import IntlString from '../intl-string';

import style from './youtube.module.scss';

const Youtube = memo(
	/**
	 * @param {{
	 *   videoId: string,
	 *   title?: null | import("../../../tmp/graphql-types").IntlStringFragment,
	 * }} props
	 */
	function Youtube({videoId, title}) {
		return (
			<Block padding>
				{title && (
					<h1 className={style.title}>
						<IntlString {...title} />
					</h1>
				)}

				<div className={style.playerWrapper}>
					<YtPlayer
						url={`https://www.youtube.com/watch?v=${videoId}`}

						// `light`: "Set to true to show just the video thumbnail,
						// which loads the full player on click"
						// needs 2 clicks to start the video
						// https://github.com/cookpete/react-player/issues/1034#issuecomment-718184362
						light={true}
						controls={true}
						width="100%"
						height="100%"
						className={style.player}
						config={{
							youtube: {
								embedOptions: {
									host: 'https://www.youtube-nocookie.com',
								},
							},
						}}
					/>
				</div>
			</Block>
		);
	}
);

export default Youtube;
